{/* EC-676 - Date Validation Handler Created */}
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { OrderHistoryDateRangeValidatorState } from "@WhiteCap/Store/Reducer/WhiteCapReducer/OrderHistoryDateRangeValidatorReducer";

// Define the handler type for handling date validation using the custom API handler
type HandlerType = CustomApiHandler<OrderHistoryDateRangeValidatorState>;

// Main handler function to process date validation changes
export const HandleDateValidationChange: HandlerType = props => {
    // Dispatch an action to update the state with the validation error
    // The action type "Custom/OrderHistory/DateValidator/SetDateError" will trigger the reducer to handle the error
    props.dispatch({
        type: "Custom/OrderHistory/DateValidator/SetDateError",
        data: props.parameter, // Pass the parameter containing the validation details
    });
};

// Define the chain of handlers for this operation
// Currently, it consists of only one handler: HandleDateValidationChange
export const chain = [HandleDateValidationChange];

// Create a chain runner for the date validation operation
// This will allow executing the chain of handlers in sequence with a unique name "SetDateValidation"
const setDateValidation = createHandlerChainRunner(chain, "SetDateValidation");

// Export the chain runner as the default export for this module
export default setDateValidation;

{/* EC-676 - Date Validation Handler Created */}
